import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PoliticaPrivacidadPage() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Política de Privacidad - VaciadoPro Barcelona';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Política de privacidad de VaciadoPro Barcelona. Información sobre el tratamiento de datos personales y protección de la privacidad de nuestros clientes.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'política privacidad, protección datos, RGPD, VaciadoPro Barcelona');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/politica-privacidad`);
    }

    // No indexar páginas legales
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, nofollow');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-green-600 to-green-700 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Política de Privacidad
              </h1>
              <p className="text-xl text-green-100">
                Protección y tratamiento de sus datos personales. 
                Conoce más sobre 
                <a href="/empresa" className="text-green-200 hover:text-white font-medium ml-1 mr-1">
                  nuestra empresa
                </a>
                y 
                <a href="/servicios" className="text-green-200 hover:text-white font-medium ml-1">
                  nuestros servicios
                </a>.
              </p>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-lg p-8">
                
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Responsable del tratamiento</h2>
                
                <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
                  <div className="space-y-3">
                    <p className="text-gray-700">
                      <strong>Identidad:</strong> VaciadoPro Barcelona
                    </p>
                    <p className="text-gray-700">
                      <strong>Dirección:</strong> Barcelona, España
                    </p>
                    <p className="text-gray-700">
                      <strong>Teléfono:</strong> +34 690 22 09 44
                    </p>
                    <p className="text-gray-700">
                      <strong>Email:</strong> info@vaciadopro.es
                    </p>
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Finalidades del tratamiento</h3>
                <div className="space-y-4 mb-6">
                  <div className="border-l-4 border-green-500 pl-6">
                    <h4 className="font-semibold text-gray-900 mb-2">Prestación de servicios</h4>
                    <p className="text-gray-700">
                      Gestionar y prestar los servicios de vaciado de pisos, trasteros y locales solicitados por el cliente.
                      Consulta todos 
                      <a href="/servicios" className="text-green-600 hover:text-green-700 font-medium ml-1">
                        nuestros servicios disponibles
                      </a>.
                    </p>
                  </div>
                  
                  <div className="border-l-4 border-blue-500 pl-6">
                    <h4 className="font-semibold text-gray-900 mb-2">Comunicación comercial</h4>
                    <p className="text-gray-700">
                      Envío de información comercial sobre nuestros servicios, promociones y novedades, 
                      siempre con el consentimiento previo del interesado.
                    </p>
                  </div>
                  
                  <div className="border-l-4 border-yellow-500 pl-6">
                    <h4 className="font-semibold text-gray-900 mb-2">Gestión de consultas</h4>
                    <p className="text-gray-700">
                      Atender y responder a las consultas, solicitudes de información y presupuestos realizados 
                      a través de nuestros canales de contacto. Visita nuestra 
                      <a href="/contacto" className="text-green-600 hover:text-green-700 font-medium ml-1">
                        página de contacto
                      </a> 
                      para más información.
                    </p>
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Base legal del tratamiento</h3>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                      <span><strong>Ejecución contractual:</strong> Para la prestación de los servicios contratados</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                      <span><strong>Consentimiento:</strong> Para el envío de comunicaciones comerciales</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                      <span><strong>Interés legítimo:</strong> Para la gestión de consultas y mejora de servicios</span>
                    </li>
                  </ul>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Datos que recopilamos</h3>
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                      <i className="ri-user-line text-green-600 mr-2"></i>
                      Datos de identificación
                    </h4>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>• Nombre y apellidos</li>
                      <li>• DNI/NIE</li>
                      <li>• Teléfono</li>
                      <li>• Email</li>
                    </ul>
                  </div>
                  
                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                      <i className="ri-map-pin-line text-green-600 mr-2"></i>
                      Datos del servicio
                    </h4>
                    <ul className="text-sm text-gray-700 space-y-1">
                      <li>• Dirección del inmueble</li>
                      <li>• Tipo de vaciado</li>
                      <li>• Fecha del servicio</li>
                      <li>• Observaciones especiales</li>
                    </ul>
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Conservación de datos</h3>
                <p className="text-gray-700 mb-6">
                  Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad 
                  para la que se recabaron y para determinar las posibles responsabilidades que se pudieran derivar 
                  de dicha finalidad y del tratamiento de los datos. Los datos se conservarán mientras se mantenga 
                  la relación comercial y, posteriormente, durante los plazos legalmente establecidos.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Destinatarios de los datos</h3>
                <p className="text-gray-700 mb-4">
                  Sus datos personales no serán comunicados a terceros, salvo en los siguientes casos:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
                  <li>Cuando sea necesario para la prestación del servicio contratado</li>
                  <li>Cuando exista una obligación legal</li>
                  <li>Cuando sea necesario para la defensa de nuestros intereses legítimos</li>
                  <li>Proveedores de servicios tecnológicos que actúen como encargados del tratamiento</li>
                </ul>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Derechos del interesado</h3>
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
                  <h4 className="font-semibold text-yellow-800 mb-3">Puede ejercer los siguientes derechos:</h4>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <ul className="text-yellow-700 space-y-2">
                        <li className="flex items-center">
                          <i className="ri-eye-line mr-2"></i>
                          <span>Derecho de acceso</span>
                        </li>
                        <li className="flex items-center">
                          <i className="ri-edit-line mr-2"></i>
                          <span>Derecho de rectificación</span>
                        </li>
                        <li className="flex items-center">
                          <i className="ri-delete-bin-line mr-2"></i>
                          <span>Derecho de supresión</span>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <ul className="text-yellow-700 space-y-2">
                        <li className="flex items-center">
                          <i className="ri-pause-line mr-2"></i>
                          <span>Derecho de limitación</span>
                        </li>
                        <li className="flex items-center">
                          <i className="ri-download-line mr-2"></i>
                          <span>Derecho de portabilidad</span>
                        </li>
                        <li className="flex items-center">
                          <i className="ri-close-line mr-2"></i>
                          <span>Derecho de oposición</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Ejercicio de derechos</h3>
                <p className="text-gray-700 mb-4">
                  Para ejercer sus derechos, puede dirigirse a nosotros mediante:
                </p>
                <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
                  <div className="space-y-2">
                    <p className="flex items-center text-gray-700">
                      <i className="ri-mail-line text-green-600 mr-3"></i>
                      <strong>Email:</strong> info@vaciadopro.es
                    </p>
                    <p className="flex items-center text-gray-700">
                      <i className="ri-phone-line text-green-600 mr-3"></i>
                      <strong>Teléfono:</strong> +34 690 22 09 44
                    </p>
                  </div>
                  <p className="text-sm text-gray-600 mt-4">
                    Deberá acompañar copia de su DNI o documento identificativo equivalente. 
                    También puede usar nuestro 
                    <a href="/contacto" className="text-green-600 hover:text-green-700 font-medium ml-1">
                      formulario de contacto
                    </a>.
                  </p>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Autoridad de control</h3>
                <p className="text-gray-700 mb-6">
                  Si considera que el tratamiento de sus datos personales vulnera la normativa, puede presentar 
                  una reclamación ante la Agencia Española de Protección de Datos (AEPD) a través de su sitio web 
                  www.aepd.es o en su sede ubicada en C/ Jorge Juan, 6, 28001 Madrid.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Seguridad de los datos</h3>
                <p className="text-gray-700 mb-6">
                  VaciadoPro Barcelona ha adoptado las medidas técnicas y organizativas necesarias para garantizar 
                  la seguridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Modificaciones</h3>
                <p className="text-gray-700 mb-6">
                  Esta política de privacidad puede ser modificada. Le recomendamos revisar periódicamente esta página 
                  para estar informado de cualquier cambio. Los cambios entrarán en vigor en el momento de su publicación.
                </p>

                <div className="mt-8 pt-6 border-t border-gray-200">
                  <p className="text-sm text-gray-500">
                    <strong>Última actualización:</strong> Diciembre 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
